import { OnBoardingGuard } from './shared/on-boarding.guard';
import { NgModule } from '@angular/core';
import { Routes, RouterModule, ExtraOptions } from '@angular/router';
import { GlobalInitGuard } from './shared/global-init.guard';
import { IsLoggedGuard } from './shared/isLogged.guard';

const routes: Routes = [

  {
    path: 'download',
    canActivate: [IsLoggedGuard],
    loadChildren: () =>
      import('./download-page/download-page.module').then(
        (m) => m.DownloadPageModule
      ),
  },
  {
    path: 'evenements',
    canActivate: [IsLoggedGuard],
    loadChildren: () =>
      import('./evenements/evenements.module').then((m) => m.EvenementsModule),
  },
  {
    path: '500',
    loadChildren: () =>
      import('./errors/error500/error500.module').then(
        (m) => m.Error500Module
      ),
  },
  // {
  //   path: 'file',
  //   loadChildren: () =>
  //     import('./download-page/download-page.module').then(
  //       (m) => m.DownloadPageModule
  //     ),
  // },
  {
    path: '',
    canActivate: [GlobalInitGuard],
    children: [
      {
        path: '',
        redirectTo: '/home',
        pathMatch: 'full'
      },
      {
        path: '500',
        redirectTo: '/home/500',
        pathMatch: 'full'
      },
      {
        path: 'on-boarding',
        loadChildren: () =>
          import('./on-boarding/on-boarding.module').then(
            (m) => m.OnBoardingModule
          ),
      },
      {
        path: '',
        loadChildren: () =>
          import('./root/root.module').then((m) => m.RootModule),
        canActivate: [OnBoardingGuard],
      },
    ],
  },
  {
    path: 'profile',
    loadChildren: () =>
      import('./root/my-profile/my-profile-page.module').then(
        (m) => m.MyProfilePageModule
      ),
  },
  { path: 'news-page', loadChildren: () => import('./root/all-news/news-page/news-page.module').then(m => m.NewsPageModule) },

  {
    path: '**',
    loadChildren: () =>
      import('./errors/error404/error404.module').then(
        (m) => m.Error404Module
      ),
  },
];

const routerOptions: ExtraOptions = {
  useHash: false,
  anchorScrolling: 'enabled',
  scrollPositionRestoration: 'enabled',
  relativeLinkResolution: 'legacy'
}

@NgModule({
  imports: [RouterModule.forRoot(routes, routerOptions)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
